import Model from "../Model";

export default class ContactData extends Model {
  name!: string;
  content!: string;
  icon!: string;
}
